import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import DateFormat from "components/LM/common/DateFormat";
import FormDatesSearch from "components/LM/common/FormDatesSearch";
import AdvancedTable from "components/LM/common/AdvancedTable";
import K2Api from "lib/ajax/K2Api";
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import './validationAuditLogs.scss';

const k2Api = new K2Api();

const TABLE_COLUMNS = [
	{ name: "actor", alias: "Actor" },
	{ name: "message", alias: "Message" },
	{ name: "date", alias: "Date" },
];

function AutoSubmitFormDatesSearch({ onSubmit, ...props }) {
	const submitted = useRef(false);
	useEffect(() => {
		if (onSubmit && !submitted.current) {
			submitted.current = true;
			const now = new Date();
			const weekAgo = new Date();
			weekAgo.setDate(weekAgo.getDate() - 7);
			onSubmit({
				beginDate: startOfDay(weekAgo).toISOString(),
				endDate: endOfDay(now).toISOString(),
			});
		}
	}, [onSubmit]);
	return <FormDatesSearch onSubmit={onSubmit} {...props} />;
}

function ValidationAuditLogs({ voiceId, voiceName }) {
	return (
		<div className="val-logs">
			<div className="val-logs__header">
				<h3 className="val-logs__title">{voiceName} / Audit logs</h3>
			</div>
			<AdvancedTable
				columns={TABLE_COLUMNS}
				onSearch={(params) => voiceLogsSearch(voiceId, params)}
				onResults={processResponse}
				pageSize={5}
			>
				<AutoSubmitFormDatesSearch />
			</AdvancedTable>
		</div>
	);
}

async function voiceLogsSearch(voiceId, { beginDate, endDate, page, pageSize }) {
	const from = (page - 1) * pageSize;
	const request = { beginDate, endDate, from, size: pageSize };
	const response = await k2Api.get(`/voice/logs/${voiceId}`, { params: request });
	return response.data;
}

function processResponse(response) {
	const total = response.total;
	const rows = response.logs.map((row) => {
		return {
			...row,
			id: row.date,
			date: <DateFormat>{row.date}</DateFormat>,
		};
	});
	return { total, rows };
}

ValidationAuditLogs.propTypes = {
	voiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	voiceName: PropTypes.string,
};

export default ValidationAuditLogs;
